import { useAuthStore } from '../state/auth-store';

export const useAuth = () => {
  const { user, token, status, error, login, logout, setTokenFromCallback } = useAuthStore();
  
  return {
    user,
    token,
    status,
    error,
    isLoading: status === 'loading',
    isAuthenticated: status === 'authenticated',
    login,
    logout,
    setTokenFromCallback,
  };
};


